<template>
    <div class="scroll-to-top" v-on:click="toTop"><i class="las la-angle-up"></i></div>
</template>
<script>
export default {
    data() {
      return {
        scTimer: 0,
        scY: 0,
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll: function () {
        if (this.scTimer) return;
        this.scTimer = setTimeout(() => {
          this.scY = window.scrollY;
          clearTimeout(this.scTimer);
          this.scTimer = 0;
        }, 100);
      },
      toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },
    },
}
</script>

<style lang="scss">
.scroll-to-top {
    position: fixed;
    right: 2rem;
    bottom: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 6rem;
    height: 6rem;
    background: var(--color-primary);
    color: var(--color-white);
    font-size: 2rem;
    border-radius: 50%;
    box-shadow: 0 2px 5px 0px rgb(0 0 0 / 30%);
    cursor: pointer;
}
</style>
